import { useEffect, useRef, useState } from "react";
import { assetUrl } from "../../utils/api";

export default function ConsultantClients() {
  const consultantId = localStorage.getItem("consultant_id");
  const bottomRef = useRef(null);
  const prevMessageCountRef = useRef(0);

  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [messages, setMessages] = useState([]);
  const [content, setContent] = useState("");
  const [loadingClients, setLoadingClients] = useState(true);

  useEffect(() => {
    fetchClients();
  }, []);

  useEffect(() => {
    if (!selectedClient) {
      return;
    }

    fetchMessages(selectedClient);

    const timer = setInterval(() => {
      fetchMessages(selectedClient);
    }, 6000);
    //////////


    return () => clearInterval(timer);
  }, [selectedClient]);



 useEffect(() => {
  if (messages.length > prevMessageCountRef.current) {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }

  prevMessageCountRef.current = messages.length;
}, [messages]);


  const fetchClients = async () => {
    try {
      const res = await fetch(
        `/api/consultant/conversations/${consultantId}`
      );
      const data = await res.json();
      const list = Array.isArray(data) ? data : [];

      setClients(list);

      if (list.length > 0 && !selectedClient) {
        setSelectedClient(list[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingClients(false);
    }
  };

  const fetchMessages = async (client) => {
    try {
      const query = new URLSearchParams({
        consultant_id: String(consultantId),
      });

      if (client.user_id) {
        query.set("user_id", String(client.user_id));
      } else {
        query.set("guest_id", client.guest_id);
      }

      const res = await fetch(
        `/api/consultant/messages?${query.toString()}`
      );
      const data = await res.json();
      setMessages(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  };

  const sendMessage = async () => {
    const text = content.trim();

    if (!selectedClient || !text) {
      return;
    }

    const payload = {
      consultant_id: Number(consultantId),
      sender_type: "consultant",
      content: text,
    };

    if (selectedClient.user_id) {
      payload.user_id = selectedClient.user_id;
    } else {
      payload.guest_id = selectedClient.guest_id;
      payload.guest_name = selectedClient.guest_name;
      payload.guest_contact = selectedClient.guest_contact;
    }

    try {
      const res = await fetch("/api/consultant/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(getErrorMessage(data, "发送失败"));
        return;
      }

      setMessages((prev) => [...prev, data.message]);
      setContent("");
      fetchClients();
    } catch (err) {
      console.error(err);
      alert("发送失败");
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">来访者</h1>

      <div className="grid grid-cols-12 gap-6">
        <aside className="col-span-12 md:col-span-4 border rounded-2xl overflow-hidden">
          <div className="p-4 border-b bg-gray-50 font-bold">客户列表</div>

          {loadingClients ? (
            <div className="p-6 text-gray-400">加载中...</div>
          ) : clients.length === 0 ? (
            <div className="p-6 text-gray-400">暂无客户消息</div>
          ) : (
            <div className="divide-y">
              {clients.map((client) => {
                const active =
                  selectedClient?.conversation_key === client.conversation_key;
                const name = getClientName(client);
                const avatar = assetUrl(client.avatar) || "/default-avatar.png";

                return (
                  <button
                    key={client.conversation_key}
                    onClick={() => setSelectedClient(client)}
                    className={`w-full p-4 text-left flex gap-3 hover:bg-blue-50 ${
                      active ? "bg-blue-50" : "bg-white"
                    }`}
                  >
                    <img
                      src={avatar}
                      alt={name}
                      className="w-12 h-12 rounded-full object-cover bg-gray-100"
                    />

                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between gap-2">
                        <p className="font-bold truncate">{name}</p>

                        {!client.user_id ? (
                          <span className="text-xs bg-orange-100 text-orange-600 rounded-full px-2 py-0.5">
                            游客
                          </span>
                        ) : null}
                      </div>

                      <p className="text-sm text-gray-400 truncate mt-1">
                        {client.last_message || "暂无消息"}
                      </p>

                      <p className="text-xs text-gray-300 mt-1">
                        {client.last_time
                          ? new Date(client.last_time).toLocaleString()
                          : ""}
                      </p>
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </aside>

        <section className="col-span-12 md:col-span-8 border rounded-2xl overflow-hidden flex flex-col min-h-[620px]">
          {!selectedClient ? (
            <div className="flex-1 flex items-center justify-center text-gray-400">
              请选择一个客户
            </div>
          ) : (
            <>
              <div className="p-4 border-b bg-gray-50 flex items-center gap-3">
                <img
                  src={assetUrl(selectedClient.avatar) || "/default-avatar.png"}
                  alt={getClientName(selectedClient)}
                  className="w-11 h-11 rounded-full object-cover bg-gray-100"
                />

                <div>
                  <h2 className="font-bold">{getClientName(selectedClient)}</h2>
                  <p className="text-sm text-gray-400">
                    {selectedClient.user_id
                      ? selectedClient.city || "未填写城市"
                      : selectedClient.guest_contact || "游客未填写联系方式"}
                  </p>
                </div>
              </div>

              <div className="flex-1 p-5 bg-gray-50 overflow-y-auto space-y-4">
                {messages.length === 0 ? (
                  <div className="text-center text-gray-400 mt-20">
                    暂无聊天记录
                  </div>
                ) : (
                  messages.map((msg) => {
                    const isMe = msg.sender_type === "consultant";

                    return (
                      <div
                        key={msg.id}
                        className={`flex ${
                          isMe ? "justify-end" : "justify-start"
                        }`}
                      >
                        <div
                          className={`max-w-[70%] rounded-2xl px-4 py-3 ${
                            isMe
                              ? "bg-blue-500 text-white"
                              : "bg-white text-gray-700 border"
                          }`}
                        >
                          <p className="whitespace-pre-wrap">{msg.content}</p>
                          <p
                            className={`text-xs mt-2 ${
                              isMe ? "text-blue-100" : "text-gray-400"
                            }`}
                          >
                            {msg.created_at
                              ? new Date(msg.created_at).toLocaleString()
                              : ""}
                          </p>
                        </div>
                      </div>
                    );
                  })
                )}

                <div ref={bottomRef} />
              </div>

              <div className="border-t p-4 flex gap-3">
                <textarea
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  placeholder="回复客户消息..."
                  rows={2}
                  className="flex-1 border rounded-xl px-4 py-3 resize-none outline-none focus:ring-2 focus:ring-blue-300"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      sendMessage();
                    }
                  }}
                />

                <button
                  onClick={sendMessage}
                  className="px-6 py-3 rounded-xl bg-blue-500 hover:bg-blue-600 text-white font-bold"
                >
                  发送
                </button>
              </div>
            </>
          )}
        </section>
      </div>
    </div>
  );
}

function getClientName(client) {
  if (client.user_id) {
    return client.name || "登录用户";
  }

  return client.guest_name || "游客";
}


function getErrorMessage(data, fallback) {
  if (!data) {
    return fallback;
  }

  if (typeof data.detail === "string") {
    return data.detail;
  }

  if (Array.isArray(data.detail)) {
    return data.detail
      .map((item) => item.msg || item.message || JSON.stringify(item))
      .join("\n");
  }

  if (typeof data.detail === "object") {
    return data.detail.message || data.detail.msg || JSON.stringify(data.detail);
  }

  return fallback;
}
